import React from "react";
import CountiesPageGen from "./generated/CountiesPageGen";
import countiesService from "../../../services/legacy/countiesService";

const SHOW_IN_GRID = new Set(["countyid", "name", "stateid", "countryid", "countycode"]);
const SHOW_IN_FILTER = new Set(["countyid", "name", "stateid", "countryid", "countycode"]);

const transformColumns = (baseColumns) => {
  return baseColumns.map((column) => ({
    ...column,
    showInGrid: SHOW_IN_GRID.has(column.key),
    showInFilter: SHOW_IN_FILTER.has(column.key),
  }));
};

const CountiesPage = () => {
  const service = countiesService;
  return <CountiesPageGen service={service} transformColumns={transformColumns} />;
};

export default CountiesPage;